import * as React from "react"
import { Link } from "gatsby"
import {bgStyle,linkStyle,footerFontSize} from './footer.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faWheelchair } from '@fortawesome/free-solid-svg-icons'

const CorporateFooter = ()=>{
    return(
        <>
            <section className={bgStyle+' '+footerFontSize}>
                <br />
                <br />
                <div className=" container">
                    <div className="columns is-mobile is-multiline">
                        <div className="column">
                            <p>
                            <Link to="/search/" className={`${linkStyle} footer-link-search`}>Apartment Search</Link>
                            </p>
                            <p>
                                <Link to="/communities/ann-arbor/" className={`${linkStyle} footer-link-annarbor-apartments`}>Ann Arbor Apartments</Link>
                            </p>
                            <p>
                                <Link to="/communities/orlando/" className={`${linkStyle} footer-link-orlando-apartments`}>Orlando Apartments</Link>
                            </p>
                        </div>
                        <div className="column">
                            <p>
                            <Link to="/about/" className={`${linkStyle} footer-link-about`}>About McKinley</Link>
                            </p>
                            <p>
                            <Link to="/about/#leadership" className={`${linkStyle} footer-link-leadership`}>Leadership</Link>
                            </p>
                            <p>
                            <Link to="/cares/" className={`${linkStyle} footer-link-supports`}>McKinley Cares</Link>
                            </p>
                        </div>
                        <div className="column">
                            <p>
                                <a href="https://recruitingbypaycor.com/career/CareerHome.action?clientId=8a7883c693417f2f01934a99e411055a" className={`${linkStyle} footer-link-careers`} target="_blank" rel="noopener noreferrer">McKinley Careers</a>
                            </p>
                            <p>
                            <Link to="/career/" className={`${linkStyle} footer-link-career-development`}>Career Development</Link>
                            </p>
                            <p>
                                <a href="https://www.facebook.com/MckinleyCompaniesLLC" target="_blank"><img src="/imgs/facebook.png" alt="facebook"/></a>&nbsp;&nbsp;&nbsp;
                                <a href="https://www.instagram.com/mckinley.living/?igsh=OHhkYm1zemJpMTNw&utm_source=qr" target="_blank"><img src="/imgs/instagram.png" alt="instagram"/></a>&nbsp;&nbsp;&nbsp;
                                <a href="http://www.linkedin.com/company/mckinley" target="_blank"><img src="/imgs/linkedin.png" alt="linked in"/></a>
                            </p>
                        </div>
                        <div className="column">
                            <p>
                            <Link to="/policy/" className={`${linkStyle} footer-link-privacy-policy`}>Privacy Policy</Link>
                            </p>
                            <p>
                            <Link to="/contact/" className={`${linkStyle} footer-link-contact-us`}>Contact Us</Link>
                            </p>
                            <p>
                                <a href="https://my.mckinley.com" className={`${linkStyle} footer-link-resident-login`} target="_blank" rel="noopener noreferrer">Resident Login</a>
                            </p>
                            <p>
                            <Link to="/blog/" className={`${linkStyle} footer-link-blog`}>McKinley Living</Link>
                            </p>
                        </div>
                    </div>
                    <div className="columns is-mobile">
                        <div className="column ">
                           <h2><img src="/imgs/mcklogo.png" alt="A McKinley Property" style={{maxWidth:'90px'}}/></h2> &copy; 2022 - 2025 McKinley Companies LLC
                        </div>
                        <div className="column">
                            Equal Housing Opportunity Provider
                            <svg className="mb-2" width="21" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 13.48 12.64" style={{position:'relative',left:'10px',top:'10px'}}><title>HUD Logo</title><path d="M11.78,11.16H1.67V4.72l5.06-3,5.06,3ZM6.74,0,0,4.05v8.58H13.48V4.05ZM4,9.5H9.51V7.76H4ZM4,7.26H9.51V5.52H4Z" style={{fill:'#ffffff'}}></path></svg>
                            &nbsp;
                            &nbsp;
                            &nbsp;
                            <FontAwesomeIcon icon={ faWheelchair } style={{fontSize:'20px'}}  />
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default CorporateFooter 
